import { useState } from 'react';
import { Copy, Check } from 'lucide-react';

// One-click "copy a shareable link" button. Styled with the comp-home .btn
// classes, so render it inside a .comp-home container. Pass an absolute `url`
// to copy a different page's link; omit it to copy the current page URL.
export function CopyLinkButton({
  url,
  label = 'Copy link',
  className = 'btn btn-ghost',
}: {
  url?: string;
  label?: string;
  className?: string;
}) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url ?? window.location.href);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {
      // Clipboard blocked (rare, non-secure context) — leave the label as-is.
      setCopied(false);
    }
  };

  return (
    <button type="button" className={className} onClick={copy}>
      {copied
        ? <><Check size={16} strokeWidth={2.5} /> Link copied</>
        : <><Copy size={16} strokeWidth={2.5} /> {label}</>}
    </button>
  );
}
